import React, { useState, useEffect, useRef } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import classNames from 'classnames';
import { Toast } from 'primereact/toast';
import { loading } from '../actions'
import { getDiagnostico, RegistroMatricula,updateMatricula } from '../service/Matricula';
import { Image } from 'primereact/image';
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment';
import { InputSwitch } from 'primereact/inputswitch';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';

export const DialogMatricula = ({visible,handleClose,data,neww}) => {

    const toast = useRef(null);
    const dispatch = useDispatch();
    //Dialog Matricula
    const [dataMatricula, setDataMatricula] = useState(null);
    const [dataMatriculaSend, setDataMatriculaSend] = useState([]);
    const [originalRows, setOriginalRows] = useState({});
    const [showDialogMatricula, setShowDialogMatricula] = useState(visible);
    const [neeArray, setNeeArray] = useState([]);
    const [diagArray, setDiagArray] = useState([]);
    const [diagArrayFilter, setDiagArrayFilter] = useState([]);

    const newwR = useRef(null);

    useEffect(() => {
        loadData(data);
        newwR.current = neww;
        setShowDialogMatricula(visible)
        console.log('renderrrrr Dialog Matricula')
    }, [visible]);

    const { usuario, colegio, anio } = useSelector(state => ({
        usuario: state.usuario,
        colegio: state.colegio,
        anio: state.anio
    }))

    useEffect(() => {
        loadDiagnostico();
    }, []);

    const loadDiagnostico = async () => {

        dispatch(loading(true));

        let data = await getDiagnostico(usuario.token);
        if (data.error == 0) {
            setNeeArray(data.tipo_nee);
            setDiagArray(data.diagnostico);
        } else {
            if (data.error == 1) {
                toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
            } else {
                console.log('Error');
            }
        }

        dispatch(loading(false));

    }

    const loadData = async (data) => {
      
        if (data===null) return ;

        let dataMat = [];
            dataMat[0] = {
                id : data.id,
                idmatricula: data.idmatricula,
                r: data.rbd,
                no: data.nombres,
                pa: data.apellido_paterno,
                ma: data.apellido_materno,
                nee: { tipo_nee: data.tipo_nee, idtipo_nee: data.idtipo_nee },
                diag: { diagnostico: data.diagnostico, iddiagnostico: data.iddiagnostico, idtipo_nee: data.idtipo_nee },
                obs: data.observacion,
                adi: data.adicional===1?true:false,
                edit: false
            }
        setDataMatricula(dataMat);
    }

    const onEditorValueChangeMatri = (props, value) => {

        let updatedProducts = [...props.value];
        updatedProducts[props.rowIndex][props.namecol] = value;
        updatedProducts[props.rowIndex]['edit'] = true;
        setDataMatricula(updatedProducts);

        if (props.namecol === 'nee') {
            setDiagArrayFilter(diagArray.filter(o => o.idtipo_nee == value.idtipo_nee))
        }

    };

    const checkEditorS = (options) => {

        return (
            <>
                <InputSwitch checked={options.rowData[options.field]} onChange={(e) => onEditorValueChangeMatri(options, e.value)} />
            </>

        );
    }

    const checkEditor = (data, options) => {

        return (
            <>
                <InputSwitch checked={options.rowData[options.field]} disabled onChange={(e) => onEditorValueChangeMatri(options, e.value)} />
            </>

        );
    }

    const textEditor = (options) => {

        return <InputText type="text" value={options.rowData[options.field]} onChange={(e) => onEditorValueChangeMatri(options, e.target.value)} />;
    }


    const drowEditorTipoNee = (options) => {

        return (
            <Dropdown
                value={options.rowData[options.namecol]}
                options={neeArray}
                optionLabel='tipo_nee'
                //optionValue="code"
                onChange={(e) => onEditorValueChangeMatri(options, e.target.value)}
                style={{ width: "100%" }}
                placeholder="--Seleccionar-"
                itemTemplate={(option) => {
                    return (
                        <span
                            className={`product-badge status-${option.tipo_nee}`}
                        >
                            {option.tipo_nee}
                        </span>
                    );
                }}
            />
        );
    };

    const drowEditorDiag = (options) => {

        return (
            <Dropdown
                value={options.rowData[options.namecol]}
                options={diagArray.filter(o => o.idtipo_nee == options.rowData.nee.idtipo_nee)}
                optionLabel='diagnostico'
                //optionValue="code"
                onChange={(e) => onEditorValueChangeMatri(options, e.target.value)}
                style={{ width: "100%" }}
                placeholder="--Seleccionar-"
                itemTemplate={(option) => {
                    return (
                        <span
                            className={`product-badge status-${option.diagnostico}`}
                        >
                            {option.diagnostico}
                        </span>
                    );
                }}
            />
        );
    };


    /////  Dialog Matricular

    const hideDialogMatri = () => {
        setShowDialogMatricula(false);
        setDataMatricula(null);
        handleClose(false);
    }

    const accept = async () => {

        let data = await updateMatricula(dataMatricula[0].id,dataMatricula[0].adi==true?1:0,dataMatricula[0].diag.iddiagnostico,dataMatricula[0].obs, usuario.token);
            if (data.error == 0) {
                toast.current.show({ severity: 'success', summary: 'OK', detail: "Se actualizo la Matricula", life: 3000 });
                setShowDialogMatricula(false);
                setDataMatricula(null);
                handleClose(true);
    
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
                } else {
                    console.log('Error');
                }
            }
    
      }

    const confirmActualizarDiagnostico = () => {
        confirmDialog({
          message: 'Estas seguro de actualizar el Diagnóstico?',
          header: 'Confirmar',
          icon: 'pi pi-info-circle',
          acceptClassName: 'p-button-success',
          accept
        });
      };

    const saveMatricula = async () => {

        if(newwR.current){

            let dataMatriculaSend = [];
            let index = 0;
            let edit = false;
            dataMatricula.forEach(element => {
                let d = { adicional: element.adi ? 1 : 0, iddiagnostico: element.diag.iddiagnostico, idmatricula: element.id_ficha, observacion: element.obs };
                dataMatriculaSend[index] = d;
                if (element.edit === true) {
                    edit = true
                }
                index++;
    
            });
    
            let data = await RegistroMatricula(dataMatriculaSend, colegio.id, anio.anio, usuario.token);
            if (data.error == 0) {
                toast.current.show({ severity: 'success', summary: 'OK', detail: "Alumnos Matriculados", life: 3000 });
                setShowDialogMatricula(false);
                setDataMatricula(null);
                handleClose(true);
    
            } else {
                if (data.error == 1) {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: data.mensaje, life: 3000 });
                } else {
                    console.log('Error');
                }
            }


        }else{
            if(dataMatricula[0].diag.iddiagnostico!==data.iddiagnostico){
                confirmActualizarDiagnostico();
            }else{
              accept();
            }
        }
    }


    const onRowEditInit = (event) => {
        originalRows[event.index] = { ...dataMatricula[event.index] };
    };

    const onRowEditCancel = (event) => {

        let products = [...dataMatricula];
        products[event.index] = originalRows[event.index];
        delete originalRows[event.index];
        setDataMatricula(products);
    };


    const matriculaDialogFooter = (
        <>
            <Button label="Cancelar" icon="pi pi-times" className="p-button-text" onClick={hideDialogMatri} />
            <Button label="Actualizar" icon="pi pi-check" onClick={saveMatricula} />
        </>
    );





    return (


        <div className="p-grid table-demo" style={{ height: '100%' }}>
         
            <div className="p-col-12" >
                <div className="" style={{ height: '100%' }}>
                    <Toast ref={toast} />

                    <Dialog visible={showDialogMatricula} style={{width: '75vw'}} breakpoints={{'960px': '100vw'}} header="Matricula" modal={true} footer={matriculaDialogFooter} onHide={hideDialogMatri}>

                        <div className="datatable-editing-demo">

                            <DataTable value={dataMatricula} id="date" editMode="row" dataKey="id" onRowEditInit={onRowEditInit}
                                onRowEditCancel={onRowEditCancel} responsiveLayout="scroll">

                                <Column namecol="r" field="r" header="RBD" style={{ width: '8%' }} ></Column>
                                <Column namecol="no" field="no" header="Nombres" style={{ width: '10%' }} ></Column>
                                <Column namecol="pa" field="pa" header="Paterno" style={{ width: '10%' }}></Column>
                                <Column namecol="ma" field="ma" header="Materno" style={{ width: '10%' }} ></Column>
                                <Column namecol="nee" field="nee.tipo_nee" header="Tipo NEE" editor={(options) => drowEditorTipoNee(options)} style={{ width: '15%' }} ></Column>
                                <Column namecol="diag" field="diag.diagnostico" header="Diagnostico" editor={(options) => drowEditorDiag(options)} style={{ width: '15%' }} ></Column>
                                <Column namecol="obs" field="obs" header="Observación" editor={(options) => textEditor(options)} style={{ width: '20%' }} ></Column>
                                <Column namecol="adi" field="adi" header="Adicional" editor={(options) => checkEditorS(options)} body={checkEditor} style={{ width: '10%' }} ></Column>
                                <Column rowEditor headerStyle={{ width: '10%', minWidth: '8rem' }} bodyStyle={{ textAlign: 'center' }}  >  </Column>
                            </DataTable>

                        </div>
                    </Dialog>

                </div>
            </div>
        </div>


    )

}



